import { render, staticRenderFns } from "./ReportTemplates.vue?vue&type=template&id=0e520fbe&"
import script from "./ReportTemplates.vue?vue&type=script&lang=ts&"
export * from "./ReportTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports